var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThreeDots(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    width: 21,
    height: 5,
    viewBox: "244.059 79.95 21 5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 6762"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M244.059 82.4a2.5 2.5 0 1 1 0 .1z",
    fillRule: "evenodd",
    "data-name": "Ellipse 56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.059 82.4a2.5 2.5 0 1 1 0 .1z",
    fillRule: "evenodd",
    "data-name": "Ellipse 57"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.059 82.4a2.5 2.5 0 1 1 0 .1z",
    fillRule: "evenodd",
    "data-name": "Ellipse 58"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThreeDots);
export default __webpack_public_path__ + "static/media/threeDots.6fa26d1135ac97c87e307f732fb6a5fa.svg";
export { ForwardRef as ReactComponent };